export default __webpack_public_path__ + "add-home-location.72e637e9b97b09bd590a3c6e192c8be7.svg";